// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1IKK-","left":"StickyBox_left__197li","right":"StickyBox_right__2LMFa"};